// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poi-label {
        -webkit-user-select: none;
                user-select: none;
        transform: translate(0, -30px);
        text-wrap: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/map-components/MapPOI.css"],"names":[],"mappings":"AAAA;QACQ,yBAAiB;gBAAjB,iBAAiB;QACjB,8BAA8B;QAC9B,iBAAiB;AACzB","sourcesContent":[".poi-label {\n        user-select: none;\n        transform: translate(0, -30px);\n        text-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
